import { Fab, styled } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Card from '@/components/Card';

export const DashboardStack = styled(Stack)`
  width: 100%;
  align-items: center;
  margin-bottom: 24px;
`;

export const Content = styled('div')`
  display: grid;
  width: 100%;
  margin: 0 16px;
  max-width: 1440px;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  box-sizing: border-box;
  margin-top: 36px;
  padding-left: 48px;
  padding-right: 48px;

  @media (max-width: 1300px) {
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    grid-template-areas:
      'main'
      'sidebar';
    max-width: 1000px;
    width: 100%;
    box-sizing: border-box;
  }

  @media (max-width: 950px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      'main'
      'sidebar';
    max-width: 700px;
    width: 100%;
    box-sizing: border-box;
  }
`;

export const ColumnStack = styled(Stack)`
  flex-direction: column;
  gap: 24px;
`;

export const CardStack = styled(Stack)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`;

export const TrafficBox = styled(Box)`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const MainContent = styled('div')`
  grid-area: main;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Sidebar = styled('div')`
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const GridContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  width: 100%;
`;

export const ManufacturerBox = styled(Box)`
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export const InfoCard = styled(Card)`
  flex: 1;
  max-width: 100%;
  width: 100%;
  min-width: 250px;
  padding-left: 0;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 45%;
    min-width: 200px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 30%;
    min-width: 150px;
    padding-left: 8px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 22%;
    min-width: 250px;
    padding-left: 24px;
  }
`;

export const ServerContainer = styled(Box)`
  gap: 24px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 40%;
    display: flex;
    flex-direction: column;
  }
`;

export const ContentStack = styled(Stack)`
  margin-top: 24px;
  padding-bottom: 32px;
  gap: 24px;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    flex-direction: row;
  }
`;

export const CardTitle = styled(Stack)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  padding-bottom: 16px;
`;

export const EditionFab = styled(Fab, {
  shouldForwardProp: (prop) => prop !== 'expanded',
})<{ expanded?: boolean }>`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
  gap: 8px;
  overflow: hidden;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.palette.white['01']};
  color: ${({ theme }) => theme.palette.primary['01']};
  border: ${({ theme }) => `1px solid ${theme.palette.white['03']}`};
  transition: ${({ theme }) =>
    theme.transitions.create(['width', 'border-radius', 'padding'], {
      duration: theme.transitions.duration.shortest,
    })};

  width: ${({ expanded }) => (expanded ? 'auto' : '56px')};
  border-radius: ${({ expanded }) => (expanded ? '28px' : '50%')};
  padding: ${({ expanded }) => (expanded ? '0 20px' : '0')};
  &:hover {
    background-color: ${({ theme }) => theme.palette.white['02']};
  }
`;

export const EditBar = styled(Stack)`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 48px 0;
`;
